import { render, staticRenderFns } from "./WzcSelect.vue?vue&type=template&id=687c0346&scoped=true"
import script from "./WzcSelect.vue?vue&type=script&lang=js"
export * from "./WzcSelect.vue?vue&type=script&lang=js"
import style0 from "./WzcSelect.vue?vue&type=style&index=0&id=687c0346&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687c0346",
  null
  
)

export default component.exports